import React, { useState,useEffect } from "react";
import "./InterestModal.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiUrl, jsonAuthHeaders } from "../../config/api.js";
import { devLog } from "../../config/devLog.js";
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../../Utils/corporateVerification.js";

const InterestModal = ({ onClose, selectedPost }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const { userDetails } = useSelector((state) => state.userReducer);

  useEffect(() => {
    setName(userDetails?.name ?? "");
  }, [userDetails])

  const handleSubmit = () => {
    if (!isCorporateVerified(userDetails)) {
      toast.info("Please verify your corporate email on your profile to send interest.", {
        autoClose: 4000,
      });
      navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
      onClose();
      return;
    }
    if (name.trim() && message.trim()) {
      sendInterest();
      setName("");
      setMessage("");
      onClose();
    } else {
      alert("Please fill all fields");
    }
  };

  const sendInterest = async () =>{
    if (!isCorporateVerified(userDetails)) return;
    devLog("Sending Interest", { userId: userDetails?.userId })
     const response = await fetch(apiUrl("sendInterest"), {
            method: 'POST',
            headers: jsonAuthHeaders(),
            body: JSON.stringify({listingId:selectedPost.id, hostId:selectedPost.created_by, senderId: userDetails.userId, message:message, companyName: userDetails.companyName || ""}),
          });
    
          const data = await response.json();
          devLog("sendInterest", { ok: response.ok })

          if (response.ok) {
            toast.success("Interest submitted Successfully", {
               isLoading: false,
              autoClose: 3000,
              closeOnClick: true

            })

          }
          else if(data?.message === 'Interest already sent'){
            toast.error("You have already sent interest for this listing", {
               isLoading: false,
              autoClose: 3000,
              closeOnClick: true
            })
          }
          else {
            toast.error("Failed to submit interest. Please try again later.", {
               isLoading: false,
              autoClose: 3000,
              closeOnClick: true
            })
          }
  }

  return (
    <div className="interest-overlay">
      <div className="interest-modal">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h2>Send Interest</h2>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <textarea
          placeholder="Your Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
        <button onClick={handleSubmit}>Send Interest</button>
      </div>
    </div>
  );
};

export default InterestModal;
